import { render, staticRenderFns } from "./sch_other.vue?vue&type=template&id=4660e11a&scoped=true"
import script from "./sch_other.vue?vue&type=script&lang=js"
export * from "./sch_other.vue?vue&type=script&lang=js"
import style0 from "./sch_other.vue?vue&type=style&index=0&id=4660e11a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660e11a",
  null
  
)

export default component.exports